import React from "react";
import styled from "styled-components";
import { Flex } from "../../../../../Flex";
import { Span } from "../../../../../Span";
import { Meter } from "../../../../../../types/Meter";
import { mediaQueries } from "../../../../../../theme";

interface Props {
  idPrefix: string;
  index: number;
  meter: Meter;
}

const MeterDividerLine = styled(Flex)`
  display: none;

  ${mediaQueries.largeDevice} {
    display: flex;
    border-top: 1px solid;
    border-color: ${({ theme }) => theme.colors.neutrals.ln30};
    margin-top: ${({ theme }) => `${theme.space[3]}px`};
    margin-bottom: ${({ theme }) => `${theme.space[3]}px`};
  }
`;

const LabelWrapper = styled(Span)`
  color: ${({ theme }) => theme.colors.neutrals.dn40};
  min-width: 0;
  flex-basis: 0;
`;

const ValueWrapper = styled(Span)`
  min-width: 0;
  flex-basis: 0;
`;

export const ReviewFormPropertyDetailsMeter: React.FC<Props> = ({
  idPrefix,
  index,
  meter,
}) => {
  return (
    <>
      <Span
        display="inline-block"
        fontSize={4}
        lineHeight={4}
        fontWeight="medium"
        mt={index === 0 ? 0 : 3}
      >
        Meter {index + 1}
      </Span>

      <MeterDividerLine />

      <Flex flexDirection="row">
        <LabelWrapper lineHeight={2} flexGrow={[0.5, 0.5, 0.5, 0.4, 0.35]}>
          Location of meter
        </LabelWrapper>

        <ValueWrapper
          data-testid={`${idPrefix}-location-${index}`}
          lineHeight={2}
          ml={3}
          flexGrow={[0.5, 0.5, 0.5, 0.6, 0.65]}
        >
          {meter.location}
        </ValueWrapper>
      </Flex>
      <Flex flexDirection="row" mt={3}>
        <LabelWrapper lineHeight={2} flexGrow={[0.5, 0.5, 0.5, 0.4, 0.35]}>
          Meter serial number
        </LabelWrapper>

        <ValueWrapper
          data-testid={`${idPrefix}-serial-${index}`}
          lineHeight={2}
          ml={3}
          flexGrow={[0.5, 0.5, 0.5, 0.6, 0.65]}
        >
          {meter.serialNumber}
        </ValueWrapper>
      </Flex>
    </>
  );
};
